
import {Component, Vue} from 'vue-property-decorator'
import MaterialSelect from "@/components/material-select/index.vue";
import {apiPromotionModuleAdd1, apiPromotionModuleDetail1, apiPromotionModuleEdit1, apiShopLists} from '@/api/shop'
import {debounce} from '@/utils/util'

@Component({
  components: {
    MaterialSelect
  }
})
export default class PromotionModuleEdit extends Vue {
  identity: number | null = null;
  shopData: any[] = []
  form: any = {
    title: '',
    url: '',
    media_title: '',
    sid: '',
    // content: ''
  };

  rules = {
    title: [{required: true, message: '请输入标题', trigger: ['blur', 'change']}],
    url: [{required: true, message: '请输入链接地址', trigger: ['blur', 'change']}],
    media_title: [{required: true, message: '请输入媒体标题', trigger: ['blur', 'change']}],
    sid: [{required: true, message: '请选择商户', trigger: ['blur', 'change']}],
    // content: [{required: true, message: '请输入内容', trigger: ['blur', 'change']}],
  };

  // 点击表单提交
  onSubmit(formName: string) {
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      if (!this.identity) {
        this.handleAdd()
      } else {
        this.handleEdit()
      }
    })
  }

  // 添加推广模块
  async handleAdd(): Promise<void> {
    await apiPromotionModuleAdd1({...this.form})
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 编辑推广模块
  async handleEdit(): Promise<void> {
    await apiPromotionModuleEdit1({...this.form, id: this.identity})
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 获取详情
  async getDetailFunc(): Promise<void> {
    const res = await apiPromotionModuleDetail1({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }
  async getShopListsFn(): Promise<void> {
    const res: any = await apiShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.lists;
  }

  created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      this.getDetailFunc()
    }
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)

  }
}
